import { connect } from 'react-redux';

import PageMeta, { StateProps, DispatchProps } from './page-meta';
import { getSettings } from 'client/ducks/app/selectors';
import { setPageMeta } from 'client/ducks/app/actions';
import { State } from 'client/store';

function mapStateToProps(state: State): StateProps {
    return {
        settings: getSettings(state)
    };
}

const mapDispatchToProps = { setPageMeta };

export default connect<StateProps, DispatchProps>(
    mapStateToProps,
    mapDispatchToProps
)(PageMeta);
